import { Text } from '@mantine/core';

export function EmptyState({ children }: { children: string }) {
  return (
    <Text c="dimmed" py="lg" ta="center">
      {children}
    </Text>
  );
}
